import StoreUtil from '@store/StoreUtil';
import ILottoBetSlipState from '../types';

export default {
    selections: StoreUtil.createSimpleGetter('selections'),
    selectionsCount: (state: ILottoBetSlipState) => state.selections.length,
    undoSelections: StoreUtil.createSimpleGetter('undoSelections'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/betSlip/getters/selections.ts